module.exports = __webpack_public_path__ + "7056d8e519de817a467b6a823a805a0f.woff";